import { render, staticRenderFns } from "./c2c2Order.vue?vue&type=template&id=68fd03e6&scoped=true"
import script from "./c2c2Order.vue?vue&type=script&lang=js"
export * from "./c2c2Order.vue?vue&type=script&lang=js"
import style0 from "./c2c2Order.vue?vue&type=style&index=0&id=68fd03e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fd03e6",
  null
  
)

export default component.exports